module Hereabout.UI.Components.CommunityListComponent where

import Prelude

import Data.Array as A
import Data.Maybe (Maybe(..))
import Data.Maybe as M
import Data.String as S
import Effect.Class (class MonadEffect)
import Halogen as H
import Halogen.HTML as HH
import Halogen.HTML.Events as HE
import Halogen.HTML.Properties as HP
import Hereabout.Data.Route (Route(..), routeCodec)
import Hereabout.Effects (class Navigate, navigate)
import Hereabout.Types (Address(..), AreaCommunityDetails(..), CommunityDetails(..), Venue(..))
import Hereabout.UI.Bits (renderIcon)
import Hereabout.UI.Bulma.Classes as Bulma
import Hereabout.UI.Components.ContentComponent as ContentComp
import Routing.Duplex (print)
import Type.Proxy (Proxy(..))
import Web.Event.Event (preventDefault)
import Web.Event.Internal.Types as WE
import Web.UIEvent.MouseEvent as ME

data Action
  = NavigateToRoute WE.Event Route

type Slot id = forall q. H.Slot q Void id

type ChildSlots =
  ( contentComp :: ContentComp.Slot Unit
  )

component :: forall q o m. MonadEffect m => Navigate m => H.Component q (Array AreaCommunityDetails) o m
component =
  H.mkComponent
    { initialState: \s -> s
    , render
    , eval: H.mkEval H.defaultEval { handleAction = handleAction }
    }

renderCd :: forall m. MonadEffect m => CommunityDetails -> H.ComponentHTML Action ChildSlots m
renderCd (CommunityDetails cd) =
  HH.article [ HP.classes [ Bulma.media ] ]
    [ HH.div [ HP.classes [ Bulma.mediaLeft ] ]
      [ HH.figure [ HP.classes [ Bulma.image, Bulma.is128x128 ] ]
        [ HH.img [ HP.src $ M.fromMaybe "/hereabout-coming-soon-sq.jpg" cd.image  ]
        ]
      ]
    , HH.div [ HP.classes [ Bulma.mediaContent ] ] $
      [ HH.div [ HP.classes [ ] ]
        [ HH.a [ HP.href (print routeCodec (CommunityRoute cd.communityId)), HE.onClick \me -> NavigateToRoute (ME.toEvent me) (CommunityRoute cd.communityId) ] [HH.h1 [ HP.classes [ Bulma.isLink, Bulma.isSize3 ] ] [ HH.text cd.name ] ]
        , HH.br_
        , HH.slot_ (Proxy :: _ "contentComp") unit ContentComp.component cd.content
        ]
      ]
    ]
  -- --HH.li_ [ HH.text cd.cdName ]
  -- HH.li_ [ HH.a [ HP.href (print routeCodec (CommunityRoute cd.cdCommunityId)), HE.onClick \me -> NavigateToRoute (ME.toEvent me) (CommunityRoute cd.cdCommunityId) ] [HH.text cd.cdName] ]
    

renderAcd :: forall m. MonadEffect m => AreaCommunityDetails -> H.ComponentHTML Action ChildSlots m
renderAcd (AreaCommunityDetails acd) =
  HH.div [ HP.classes [ Bulma.block ] ]
    [ HH.h1 [ HP.classes [ Bulma.title ] ] [ HH.text acd.acdAreaName ]
    , HH.ul_ $
      map renderCd acd.acdAreaCommunities
    ]

render :: forall m. MonadEffect m => (Array AreaCommunityDetails) -> H.ComponentHTML Action ChildSlots m
render acds =
  HH.div_ $
    [ HH.div [ HP.classes [ Bulma.notification, Bulma.isInfo, Bulma.m2 ] ]
      [ HH.text "Thanks for checking out Hereabout. You might have landed on this page because we can't work out (or don't yet cover) your current location. If you don't have location services enabled on your device, please try refreshing the page with location turned on and we'll try to take you directly to your local feed. Alternatively, please check out the list of communities below to find events and venues in your area!"

      ]

    ] 
      <> map renderAcd acds


handleAction :: forall cs o m. MonadEffect m => Navigate m => Action → H.HalogenM (Array AreaCommunityDetails) Action cs o m Unit
handleAction = case _ of
  NavigateToRoute e route -> do
    H.liftEffect $ preventDefault e
    H.lift $ navigate route

